import { render, staticRenderFns } from "./cancelled.vue?vue&type=template&id=56d1161c&scoped=true"
import script from "./cancelled.vue?vue&type=script&lang=js"
export * from "./cancelled.vue?vue&type=script&lang=js"
import style0 from "./cancelled.vue?vue&type=style&index=0&id=56d1161c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1161c",
  null
  
)

export default component.exports